module.exports = __webpack_public_path__ + "static/pic02-a735bf1b82dd0794a30f417a3cf087a2.jpg";